import * as React from "react";
import clsx from "clsx";
import * as s from "../../FormInput.style.css";
import type { EmailInputProps } from "./EmailInput.types";

export const EmailInput = React.forwardRef<HTMLInputElement, EmailInputProps>(
  function EmailInput({ label, error, hint, id, className, ...rest }, ref) {
    const inputId = id ?? React.useId();
    const hintId = hint ? `${inputId}-hint` : undefined;
    const describedBy = [error ? `${inputId}-error` : undefined, hintId].filter(Boolean).join(" ") || undefined;
    return (
      <div className={s.wrapper}>
        {label && (
          <label htmlFor={inputId} className={s.label}>
            {label}
          </label>
        )}
        <input
          ref={ref}
          type="email"
          id={inputId}
          autoComplete="email"
          className={clsx(s.input, error && s.inputError, className)}
          aria-invalid={!!error}
          aria-describedby={describedBy}
          {...rest}
        />
        {error && (
          <span id={`${inputId}-error`} className={s.errorText} role="alert">
            {error}
          </span>
        )}
        {hint && !error && (
          <span id={hintId} className={s.hintText}>
            {hint}
          </span>
        )}
      </div>
    );
  }
);
